let currentFieldset = 0;
showTab(currentFieldset);

const errorMessages = {
  INTERNAL_SERVER_ERROR: "An unknown error has occurred. Please try later.",
  INVALID_CAPTCHA: "The Captcha could not be verified. Please try again.",
  WRONG_PHONE_FORMAT:
    "We apologize, but the phone number you have entered is invalid. Please ensure that you are using the correct format for phone numbers.",
  WRONG_EMAIL_FORMAT:
    'The email address you entered is not formatted correctly. Please make sure you use the proper format, which includes the "@" symbol followed by the domain name, such as example@example.com.',
  WRONG_FIRST_NAME_FORMAT:
    "Sorry, that's not a valid last name format. First names should only consist of letters and can be up to 32 characters long. Please try again using a valid format.",
  WRONG_LAST_NAME_FORMAT:
    "Sorry, that's not a valid last name format. Last names should only consist of letters and can be up to 32 characters long. Please try again using a valid format.",
  WRONG_ORGANIZATION_NAME_FORMAT:
    "Sorry, that's not a valid organization name. Organization names should only include letters and spaces, not any other characters. Please try again with a valid organization name.",
  WRONG_MESSAGE_FORMAT:
    "The message format you provided is incorrect. Please make sure to follow the guidelines for the type of message you're sending. This includes a maximum of 200 characters. Any message longer than 200 characters will be rejected. Please revise your message accordingly.",
};
function handleToastErrorMessage(message) {
  Toastify({
    text: errorMessages[message],
    className: "toast__content toast__content_error",
    duration: 3000,
    stopOnFocus: true,
  }).showToast();
}

const form = document.getElementById("application-form");

function showTab(n) {
  const nextButton = document.getElementById("next-button");
  const prevButton = document.getElementById("prev-button");
  const fieldsetElements = document.getElementsByClassName(
    "application-content__fieldset"
  );

  fieldsetElements[n].style.display = "flex";

  if (n === 0) {
    prevButton.style.display = "none";
  } else {
    prevButton.style.display = "grid";
  }
  if (n === fieldsetElements.length - 1) {
    nextButton.innerHTML = "Submit";
  } else {
    nextButton.innerHTML = "Next";
  }

  fixStepIndicator();
}

function next(n) {
  const fieldsetElements = document.getElementsByClassName(
    "application-content__fieldset"
  );

  if (n === 1 && !validateForm()) return false;

  if (n !== -1 && currentFieldset + n >= fieldsetElements.length) {
    form.requestSubmit();
    return false;
  }

  fieldsetElements[currentFieldset].style.display = "none";
  currentFieldset = currentFieldset + n;

  showTab(currentFieldset);
}

function validateForm() {
  let valid = true;
  const fieldsetElements = document.getElementsByClassName(
    "application-content__fieldset"
  );
  const inputElements = fieldsetElements[
    currentFieldset
  ].getElementsByClassName("application-content__input");

  Array.from(inputElements).forEach(function (el) {
    if (!el.validity.valid) {
      if (el.validity.valueMissing) {
        if (
          !el.classList.contains("application-content__input_invalid_required")
        ) {
          el.classList.add("application-content__input_invalid_required");
        }
      } else {
        el.classList.remove("application-content__input_invalid_required");
      }

      if (el.validity.patternMismatch) {
        if (
          !el.classList.contains("application-content__input_invalid_pattern")
        ) {
          el.classList.add("application-content__input_invalid_pattern");
        }
      } else {
        el.classList.remove("application-content__input_invalid_pattern");
      }

      if (el.validity.typeMismatch) {
        if (!el.classList.contains("application-content__input_invalid_type")) {
          el.classList.add("application-content__input_invalid_type");
        }
      } else {
        el.classList.remove("application-content__input_invalid_type");
      }

      if (!el.classList.contains("application-content__input_invalid")) {
        el.classList.add("application-content__input_invalid");
      }

      valid = false;
    } else {
      el.classList.remove(
        "application-content__input_invalid",
        "application-content__input_invalid_required",
        "application-content__input_invalid_type",
        "application-content__input_invalid_pattern"
      );
    }
  });

  return valid;
}

function fixStepIndicator() {
  const stepElements = document.getElementsByClassName(
    "application-sidebar__step"
  );

  Array.from(stepElements).forEach(function (el, idx) {
    if (idx < currentFieldset) {
      if (!el.classList.contains("application-sidebar__step_finish")) {
        el.classList.add("application-sidebar__step_finish");
      }
    } else {
      el.classList.remove("application-sidebar__step_finish");
    }

    if (idx === currentFieldset) {
      if (!el.classList.contains("application-sidebar__step_active")) {
        el.classList.add("application-sidebar__step_active");
      }
    } else {
      el.classList.remove("application-sidebar__step_active");
    }
  });
}

function handleFormSubmit(e) {
  e.preventDefault();
  e.stopPropagation();
  setLoader(true);

  grecaptcha.ready(function () {
    grecaptcha
      .execute("6Ldg7ggkAAAAAIDMr9ni_ZM78wTOKjtTt56CuvUL", { action: "submit" })
      .then(function (token) {
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);

        fetch("/corp/partnerships/apply", {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({ ...data, token }),
        })
          .then(function (resp) {
            return resp.json();
          })
          .then(function (data) {
            if (data.response.status === 0) location.assign("/success");
            if (data.error) handleToastErrorMessage(data.error.message);
            setLoader(false);
          })
          .catch(function () {
            handleToastErrorMessage("INTERNAL_SERVER_ERROR");
            setLoader(false);
          });
      });
  });
}

const loader = document.getElementById("loader");
const body = document.body;
function setLoader(state) {
  loader.style.display = state ? "flex" : "none";
  body.style.overflow = state ? "hidden" : "auto";
}
